export enum MutexKey {
  CloseProducer = 'CloseProducer',
  Mute = 'Mute',
  Resume = 'Resume',
  Join = 'Join',
  Release = 'Release',
}
